module.exports = __webpack_public_path__ + "img/menu-expandido.4b3ca4c8.svg";